// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-title {
  text-align: center;
  font-size: large;
  font-weight: 700;
}

ion-header app-custom-cart-button {
  font-size: 23px;
}

.filtros-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 8px 16px;
  background-color: var(--ion-background-color, #ffffff);
}
.filtros-container .chip-filtro {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 20px;
  padding: 7px 18px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  background-color: transparent;
  color: #666666;
  border: 1px solid #d0d0d0;
}
.filtros-container .chip-filtro.chip-activo {
  background-color: var(--ion-color-primary, #0075c9);
  color: var(--ion-color-primary-contrast, #ffffff);
  border-color: var(--ion-color-primary, #0075c9);
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.filtros-container .chip-filtro:active {
  transform: scale(0.97);
}

.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  color: var(--ion-color-medium, #666);
  font-size: 15px;
}
.loading-wrap ion-spinner {
  width: 36px;
  height: 36px;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/carrito/carrito.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,sDAAA;AAEF;AAAE;EACE,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;AAEJ;AAAI;EACE,mDAAA;EACA,iDAAA;EACA,+CAAA;EACA,gBAAA;EACA,yCAAA;AAEN;AACI;EACE,sBAAA;AACN;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ","sourcesContent":["ion-header ion-title{\n  text-align: center;\n  font-size: large;\n  font-weight: 700;\n}\nion-header app-custom-cart-button{\n  font-size: 23px;\n}\n\n.filtros-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px 8px 16px;\n  background-color: var(--ion-background-color, #ffffff);\n\n  .chip-filtro {\n    appearance: none;\n    -webkit-appearance: none;\n    outline: none;\n    cursor: pointer;\n    border-radius: 20px;\n    padding: 7px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease-in-out;\n    background-color: transparent;\n    color: #666666;\n    border: 1px solid #d0d0d0;\n\n    &.chip-activo {\n      background-color: var(--ion-color-primary, #0075c9);\n      color: var(--ion-color-primary-contrast, #ffffff);\n      border-color: var(--ion-color-primary, #0075c9);\n      font-weight: 600;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n  }\n}\n\n.loading-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 16px;\n  color: var(--ion-color-medium, #666);\n  font-size: 15px;\n\n  ion-spinner {\n    width: 36px;\n    height: 36px;\n    margin-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
